import { render, staticRenderFns } from "./ItemGroupsView.vue?vue&type=template&id=5566bce6&scoped=true&"
import script from "./ItemGroupsView.vue?vue&type=script&lang=ts&"
export * from "./ItemGroupsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5566bce6",
  null
  
)

export default component.exports